import { Widget } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React, { ReactElement, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../Base.constants';
import { useFetchArticles } from '../../../hooks/articles';
import { WIDGET_ID } from '../../../pages/Article/Article.constants';
import { isMultipartTag } from '../../../utils/tagUtils';
import { sortDocuments } from './MultipartDocuments.logic';
import styles from './MultipartDocumentsWidget.module.scss';

interface MultipartDocumentsWidgetProps {
  tag: string;
}

const cx = classNames.bind(styles);

export const DEFAULT_TAKE = 100;

const MultipartDocumentsWidget = ({ tag }: MultipartDocumentsWidgetProps): ReactElement | null => {
  const {
    isLoading,
    isError,
    refetch,
    data: articles = { rows: [], totalResults: 0 },
  } = useFetchArticles({
    take: DEFAULT_TAKE,
    page: 0,
    filters: {
      tags: [[tag]],
    },
    enabled: isMultipartTag(tag),
  });

  const sortedArticles = useMemo(() => sortDocuments(articles.rows), [articles]);

  const renderArticles = () => {
    return sortedArticles.map(({ id, content }) => (
      <Link key={id} className={cx('link')} to={ROUTES.article(id)} target="_blank" rel="noopener noreferrer">
        {content.title}
      </Link>
    ));
  };

  if (!isLoading && !isError && !sortedArticles.length) {
    return null;
  }

  return (
    <Widget
      headerTitle="Related Documents"
      fixedHeight
      dataTestId={WIDGET_ID.MULTIPART_DOCUMENTS}
      isLoading={isLoading}
      isError={isError}
      onRetryAfterErrorClick={refetch}
    >
      <div className={cx('body')} data-testid="multipart-documents">
        {renderArticles()}
      </div>
    </Widget>
  );
};

export default MultipartDocumentsWidget;
